import styled from 'styled-components';

import { ThemeType } from '../../../../themeStyled';
import { contentColorMap } from '../../contentColor';
import { fontWeightMap } from '../../fontWeight';
import commonHeadingStyles, { HeadingProps } from '../common/styles';

const H2 = styled.h2<HeadingProps>`
	${commonHeadingStyles};
	font-weight: ${({ fontWeight }) => (fontWeight ? fontWeightMap[fontWeight] : 'normal')};
	font-size: 2.5rem;
	line-height: 133%;
	color: ${({ theme, contentColor }) => (contentColor ? contentColorMap[contentColor](theme) : theme.colors.dark)};

	@media (max-width: ${({ theme }: { theme: ThemeType }) => theme.breakpoints.md}) {
		font-size: 1.75rem;
	}
`;

export default H2;
